import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DvTabLink, DvTabsComponent } from '@devinco/ui/dds';
import { TranslateService } from '@ngx-translate/core';
import { POIRouteName } from '@pages/poi-page/poi-page.module';

@Component({
  selector: 'app-poi-tabs',
  templateUrl: './poi-tabs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DvTabsComponent, RouterOutlet],
})
export class POITabsComponent {
  private readonly translate = inject(TranslateService);

  tabLinks: DvTabLink[];

  constructor() {
    this.tabLinks = [
      {
        label: this.translate.instant('POI.Information'),
        link: POIRouteName.Information,
        id: POIRouteName.Information,
      },
    ];
  }
}
